import React, { useEffect } from 'react';
// import { useRouter } from 'next/router';
import { storeSessionParams } from '@utils/services';
import Home from 'pages';

const Share = () => {
  // const router = useRouter();

  useEffect(() => {
    const BASEURL = process.env.NEXT_PUBLIC_API_URL;
    const {
      location: { href },
    } = window;

    if (href) {
      const path = href.split('share/')[1];
      const url = `${BASEURL}/share/${path}`;
      storeSessionParams(url);
    }

    // router.push('/', undefined, { shallow: true });
  }, []);

  return <Home />;
};

export default Share;
